<!-- Banners -->
<div class="form-banner-list">
  @if (siteConfig.isEFileSubmissionMaintenanceEnabled() || eFileDisabled) {
    <app-banner type="error"
      [header]="'Service Offline'"
      [message]="getMaintenanceBanner">
    </app-banner>
  }
  @if (formDetail && !formDetail.hasEFile && !devMode) {
    <app-banner
      type="info"
      [header]="'Unpublished Form'"
    [message]="'This form has not been published yet.'"></app-banner>
  }
  <app-banner type="warning"
    [header]="'Browser Disclaimer'"
  [message]="'This site is best viewed using the current browser version of Chrome, Microsoft Edge, or Firefox. Please avoid incognito mode.'"></app-banner>
  @if (formDetail && !userInfo) {
    <app-banner type="error"
      header="Not Logged In"
      message="You do not appear to be logged in. Please log in to continue." />
    }
  </div>

  <!-- Initial loading indicator -->
  @if (formLoadState === FormLoadState.loading) {
    <div class="p-2" style="display: flex; align-items: center; justify-content: center; flex-direction: column">
      <app-loading-spinner/>
      <p style="color: black; margin-top: 10px">Loading the form...</p>
    </div>
  }

  <!-- Main Form Info -->
  @if (formDetail && (formDetail.hasEFile || devMode)) {
    <div id="formTop">
      <app-progress-bar [progress]="formProgress"/>

      <div style="display: flex; gap: 5px; padding-top: 5px; padding-bottom: 5px">
        <!-- Sidebar -->
        <div class="sidebar-container">
          <app-form-outline [outlineItems]="outlineItems" [outlineItemIndex]="outlineItemIndex"/>
        </div>
        <!-- Pages -->
        <div class="form-container">
          @for (formPage of formPages; track formPage.title) {
            <div class="efile-page"
              [hidden]="pageIndex !== $index"
              [@slideInOutAnimation]="pageIndex === $index ? 'in' : (pageIndex > $index ? 'outLeft' : 'outRight')">

              <!-- Toolbar -->
              <div style="display: flex; justify-content: space-between">
                <app-assessor-button title="Return to Forms"
                  leadingIcon="fas fa-arrow-left"
                  tooltip="Clicking this option will return you to the list of forms."
                  (clickEvent)="handleReturnToFormsClicked(confirmReturnToForms)"/>

                  <div style="display: flex; gap: 10px">
                    <app-assessor-button title="E-File Instructions"
                      leadingIcon="fa-brands fa-readme"
                      (clickEvent)="handleEFileInstructionsClicked()"/>
                      <app-assessor-button title="Open Preview"
                        leadingIcon="fa-regular fa-file-pdf"
                        (clickEvent)="handlePreviewClicked(pdfPreviewPopUp)"/>
                      </div>
                    </div>
                    <hr/>

                    @if ($index === 0) {
                      @if (userInfo) {
                        <h2 style="color: #043c5a">Welcome {{ userInfo.lastName }}, {{ userInfo.firstName }} {{ userInfo.middleName }}</h2>
                      } @else {
                        <h2 style="color: #043c5a">Welcome</h2>
                      }
                      <p style="color: black">You are about to fill-out an online web-form.</p>
                      <hr>
                      }

                      <h1 style="color: black">{{ formPage.title }}</h1>

                      @for (control of formPage.controls; track control.element.id) {
                        @switch (control.element.type) {
                          @case ('template') {
                            <app-form-template-array [formGroup]="formPage.formGroup"
                              [control]="control"
                              [templates]="templates"
                              [controls]="controls"
                              [viewModel]="viewModel"/>
                            }
                            @case ('form_summary') {
                              <p style="color: black">Please review each form entry for correctness. If you need to make changes,
                              click the "Modify" button to return to that page in the form.</p>
                              @for (formPageSummary of formSummaries; track formPageSummary.title) {
                                <app-form-page-summary [pageSummary]="formPageSummary"
                                  (modifyButtonClicked)="handleModifyClicked($event)"/>
                                }
                              }
                              @case ('form_preview') {
                                <p style="color: black">Please review the form preview for correctness. After this point you will not be
                                  able to make changes. If you require changes after this point, you will need to start a new
                                submission.</p>
                                <app-form-preview [pdfFillJson]="previewJson()"/>
                              }
                              @case ('form_loading') {
                                <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                                  <app-loading-spinner/>
                                  <p style="color: black; margin-top: 10px">We're generating the form now</p>
                                </div>
                              }
                              @case ('form_error') {
                                <p style="color: black; margin-top: 10px; margin-bottom: 0">Something went wrong generating the form.
                                Please click resubmit or make corrections and try again.</p>
                                <p style="color: red; margin-top: 0"><b>{{ eFileSubmissionError }}</b></p>
                                <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                                  <div style="display: flex; flex-direction: column; gap: 10px">
                                    <app-assessor-button title="Resubmit Form"
                                      (clickEvent)="handleResubmitClicked()"/>
                                      <app-assessor-button title="Review Form"
                                        (clickEvent)="handleConfirmationClicked()"/>
                                      </div>
                                    </div>
                                  }
                                  @case ('signix_signature') {
                                    @if (!isSignixFrameLoading) {
                                      <p style="color: black">If you are unable to see the signature page below,
                                        click to <a id="fallbackSignixUrl" (click)="handleSignixTimeoutLinkClicked()">sign the document</a>.
                                        You can also sign the document from the <a href="/efile/status" target="_blank">Online Submission
                                      Status Page</a>.</p>
                                    }
                                    <!-- Show alert if mobile -->
                                    @if (formHelper.isMobileDevice()) {
                                      <alert type="info">
                                        <p class="m-3">If the pop up is blocked, please click to <a href="{{this.documentResponse?.url}}">sign
                                        the document</a></p>
                                      </alert>
                                    }
                                    <!-- Otherwise, show the desktop content -->
                                    @if (!formHelper.isMobileDevice() && !formHelper.isSafari()) {
                                      <div>
                                        @if (isSignixFrameLoading) {
                                          <div
                                            style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                                            <app-loading-spinner/>
                                            <p style="color: black">Generating the signature page</p>
                                          </div>
                                        }
                                        <iframe [style.width]="isSignixFrameLoading ? '0%' : '100%'"
                                          style="overflow:hidden; height:100vh; border: none"
                                        [src]="$safeNavigationMigration(this.documentResponse?.url) | SafeUrl" (load)="onSignixFrameLoad()"></iframe>
                                      </div>
                                    }
                                  }
                                  @default {
                                    <app-dynamic-control [formGroup]="formPage.formGroup"
                                      [control]="control"
                                      [viewModel]="viewModel"
                                    [controlCache]="controls"></app-dynamic-control>
                                  }
                                }
                              }

                              @if ($index === 0) {
                                <div class="mt-5" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px">
                                  <app-assessor-button title="View the Form"
                                    (clickEvent)="handleDownloadFormClicked()"/>
                                    <p style="color: black; margin-bottom: 0">OR</p>
                                    <app-assessor-button title="Start Online Submission"
                                      trailingIcon="fas fa-arrow-right"
                                      [isDisabled]="eFileDisabled || !userInfo"
                                      [tooltip]="eFileDisabledToolTip"
                                      (clickEvent)="handleNextClicked()"/>
                                    </div>
                                  }

                                  <!-- Navigation pages -->
                                  @if ($index > 0 && formPage.hasNavButtons) {
                                    <div class="mt-5" style="display: flex; flex-direction: column;">
                                      <hr/>
                                      <div style="display: flex; flex-direction: column; gap: 10px">
                                        <!-- Nav buttons -->
                                        <div style="display: flex; align-items: center; justify-content: center; gap: 10px">
                                          <app-assessor-button title="Previous"
                                            leadingIcon="fa-solid fa-chevron-left"
                                            [isDisabled]="doesNotHavePrevious()"
                                            (clickEvent)="handlePreviousClicked()"/>
                                            <p style="margin-bottom: 0; color: black">Page {{ outlineItemIndex + 1 }}
                                            of {{ outlineItems.length }}</p>
                                            <!-- Conditionally style next button based on the current page -->
                                            @if (formPage.type === 'form_preview') {
                                              <app-assessor-button buttonType="submit"
                                                title="Submit Form"
                                                trailingIcon="fa-regular fa-paper-plane"
                                                [isDisabled]="eFileDisabled"
                                                [tooltip]="eFileDisabledToolTip"
                                                (clickEvent)="handleConfirmSubmissionClicked(finalConfirmationPopUp)"/>
                                              } @else {
                                                <app-assessor-button title="Next"
                                                  trailingIcon="fa-solid fa-chevron-right"
                                                  [isDisabled]="eFileDisabled || !userInfo"
                                                  [tooltip]="eFileDisabledToolTip"
                                                  (clickEvent)="handleNextClicked()"/>
                                                }
                                              </div>
                                              @if (hasReturnToConfirmation) {
                                                <div style="display: flex; align-items: center; justify-content: center;">
                                                  <app-assessor-button title="Return to Confirmation"
                                                    leadingIcon="fa-regular fa-rectangle-list"
                                                    (clickEvent)="handleReturnBack()"/>
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          }

                                          @if (pageHasFormHints()) {
                                            <ng-container class="mt-5">
                                              <hr>
                                                <app-form-faq [formPage]="formPages[pageIndex]"></app-form-faq>
                                              </ng-container>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }

                                <ng-template #genericAlert>
                                  @if (viewModel.modalAlertMessage) {
                                    <div
                                      style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
                                      <h1 class="modalHeaderText">{{ viewModel.modalAlertMessage.title }}</h1>
                                      <div style="color: black; text-align: center" [innerHTML]="viewModel.modalAlertMessage.message"></div>
                                      <app-assessor-button title="Close" (clickEvent)="modalRef.hide()"/>
                                    </div>
                                  }
                                </ng-template>
                                <ng-template #confirmReturnToForms>
                                  <div
                                    style="display: flex; flex-direction: column; align-items: center; padding: 10px; gap: 5px; background: ghostwhite">
                                    <h1 class="modalHeaderText">Return to Forms</h1>
                                    <p style="color: black">If you click "Confirm Return to Forms" you will lose any unsaved form progress.</p>
                                    <div style="display: flex; flex-direction: column; gap: 5px">
                                      <app-assessor-button buttonType="cancel"
                                        title="Confirm Return to Forms"
                                        (clickEvent)="handleConfirmReturnToFormsClicked()"
                                        style="width: 100%"/>
                                        <app-assessor-button title="Stay on e-File"
                                          (clickEvent)="modalRef.hide()"
                                          style="width: 100%"/>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template #pdfPreviewPopUp>
                                      <div style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
                                        <app-form-preview [pdfFillJson]="previewJson()"/>
                                        <app-assessor-button title="Close Preview"
                                          (clickEvent)="modalRef.hide()"/>
                                        </div>
                                      </ng-template>
                                      <ng-template #finalConfirmationPopUp>
                                        <div style="padding: 20px; display: flex; flex-direction: column; gap: 5px; background: ghostwhite">
                                          <h2 style="color: black; text-align: center">Confirm Submission</h2>
                                          <p style="color: black">You are about to submit a form. After clicking Submit Form, you will be unable to make
                                          changes. If you need to make changes after this point, you will need to start a new submission.</p>

                                          <div style="display: flex; flex-direction: column; align-items: center; gap: 5px">
                                            <app-assessor-button buttonType="submit"
                                              title="Submit Form"
                                              (clickEvent)="handleSubmissionConfirmedClicked()"
                                              style="width: 50%"/>
                                              <app-assessor-button title="Return to Form Review"
                                                (clickEvent)="modalRef.hide()"
                                                style="width: 50%"/>
                                              </div>
                                            </div>
                                          </ng-template>
